import { HubCardDataOptions, useHubCardData } from './use-hub-card-data';
import { HubCardType } from '@/types';

export const useWeeklyProfitRollupData = (options?: HubCardDataOptions) => {
  const { data, loading, error } = useHubCardData(
    HubCardType.WeeklyProfitRollup,
    {
      // use default cache policy for lowest performing customers
      fetchPolicy: options?.fetchPolicy ?? 'cache-first',
      skip: options?.skip ?? false,
    },
  );

  return {
    data: data ? data.cardData[0] : undefined,
    error,
    loading,
  };
};
